import React from 'react';
import ConfiguratorWrapper from './components/ConfiguratorWrapper';

interface KonfiguratorConfig {
  products: string;
  showVisualizer: boolean;
  theme: string;
  compact: boolean;
}

interface AppProps {
  config?: KonfiguratorConfig;
  containerId?: string;
}

function App({ config, containerId }: AppProps) {
  return (
    <div className="App">
      <ConfiguratorWrapper 
        config={config} 
        containerId={containerId}
      />
    </div>
  );
}

export default App; 